import Helper from './Helper';

class InteractiveSVGPopup {
  constructor(svgSelector, defaultActive) {

    this.defaultActive = defaultActive || null;
    this.svg = document.querySelector(svgSelector);
    if (!this.svg) return;
    this.interactiveContainer = this.svg.closest('.ns-interactive-svg-container');
    this.targetItems = [...this.interactiveContainer.querySelectorAll('.ns-interactive-svg-item')];

    this.targetItems = this.targetItems.map(item => {
      let id = item.querySelector('.ns-interactive-svg-item__id').innerText;
      item.id = 'target-' + id.trim();

      return {
        match: id,
        node: item
      };
    });

    this.bindEvents();
  }

  bindEvents() {
    this.triggers = this.svg.querySelectorAll('[id^="trigger-"]');

    this.triggers.forEach(trigger => {
      let triggerID = trigger.id.split('-')[1];
      let item = this.targetItems.filter(item => item.match == triggerID);

      if (item.length > 0) {
        item = item[0];
      }

      trigger.addEventListener('click', (e) => {
        if (item) {
          if (trigger.classList.contains('active')) {
            this.deactivateAll();
          } else {
            this.deactivateAll();
            trigger.classList.add('active');
            item.node?.classList.add('active');
          }
        }
      });

      if (trigger.classList.contains('default')) {
        // trigger.click(); //click dosent work and i cant be bothered by it right now
        trigger.classList.add('active');
        this.interactiveContainer.querySelector('#target-' + triggerID).classList.add('active');
      }
    });


    this.activateDefault();
  }

  deactivateAll() {
    this.triggers.forEach(item => {
      item.classList.remove('active');
    })

    this.targetItems.forEach(item => {
      item.node.classList.remove('active');
    })
  }

  activateDefault() {
    if (!this.defaultActive) {
      return; //end
    }

    // document.querySelector(this.defaultActive)?.click();

    let activeTarget = this.targetItems.filter(targetItem => {
      return targetItem.match == this.defaultActive;
    });
    let activeTrigger = [...this.triggers].filter(trigger => {
      return trigger.id.split('-')[1] == this.defaultActive;
    });

    if (activeTarget[0])
      activeTarget[0].node?.classList.add('active');

    if (activeTrigger[0])
      activeTrigger[0].classList.add('active');
  }

}
export default InteractiveSVGPopup;
